import { Space, SpaceVertical } from '@looker/components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import type { FC } from 'react';
import DotLoader from '../../../../../../components/DotLoader';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import ChannelRecency from '../ChannelRecency';
import EngagementFilter from '../EngagementFilter';
import { Frequency } from '../FrequencyFilter';
import useEventFilterManager from '../hooks/useEventFilterManager';
import LinkedFilter from '../LinkedFilter';

const Media: FC<ICustomFilter> = ({ onChange }) => {
  const { isLoading, setIsLoading, handleChildChange } = useEventFilterManager({
    filterPrefix: 'media',
    onChange,
  });

  return (
    <SpaceVertical paddingX="u12" paddingTop="u5" gap="u5">
      <EngagementFilter
        onChange={handleChildChange}
        filterId="smart_pixel_match_type_filter"
        filterLabel="Match Type"
        matchTypeFilter
      />
      <SpaceVertical gap="u2" align="stretch">
        <Space gap="u2" align="center">
          <DsTypography variant="label">Tag Collection</DsTypography>
          {isLoading && <DotLoader />}
        </Space>

        <LinkedFilter
          filterName="smart_pixel_collection_filter"
          view="genome_suggestions_hcp365_collection"
          fields={['genome_suggestions_hcp365_collection.collection_name_suggestion']}
          pseudoAdvertiserIdFilterKey="genome_suggestions_hcp365_collection.pseudo_advertiser_id_filter"
          pseudoAccountIdFilterKey="genome_suggestions_hcp365_collection.pseudo_account_id_filter"
          warningMessage="Changing Collection will affect other Collection in Engagement"
          onChange={handleChildChange}
          onLoadingChange={setIsLoading}
        />
      </SpaceVertical>

      <SpaceVertical gap="u2" align="stretch">
        <Space gap="u2" align="center">
          <DsTypography variant="label">Campaign</DsTypography>
          {isLoading && <DotLoader />}
        </Space>

        <LinkedFilter
          filterName="media_campaign_filter"
          view="genome_suggestions_hcp365_campaign"
          fields={['genome_suggestions_hcp365_campaign.campaign_name_suggestion']}
          pseudoAdvertiserIdFilterKey="genome_suggestions_hcp365_campaign.pseudo_advertiser_id_filter"
          pseudoAccountIdFilterKey="genome_suggestions_hcp365_campaign.pseudo_account_id_filter"
          onChange={handleChildChange}
          onLoadingChange={setIsLoading}
        />
      </SpaceVertical>

      <SpaceVertical gap="u5">
        <EngagementFilter
          onChange={handleChildChange}
          filterId="media_action_filter"
          filterLabel="User Action"
          reverseOptions
        />

        <ChannelRecency onMultiFilterChange={handleChildChange} paddingX="none" />

        <Frequency
          onChange={handleChildChange}
          filterName={'media_frequency_filter'}
          label={'Frequency Control'}
          subHeading={'Only trigger if the person was exposed selected amount of times'}
          suffix={'times'}
        />
      </SpaceVertical>
    </SpaceVertical>
  );
};

export default Media;
